document.addEventListener("DOMContentLoaded", function () {
  var error404 = document.getElementsByClassName('error404');

  if (error404.length > 0) {
    var playButton = document.getElementById('play');
    var pauseButton = document.getElementById('pause');
    var bgVideo = document.getElementById('bg-video');

    if (playButton && pauseButton && bgVideo) {
      playButton.addEventListener('click', function () {
        bgVideo.play();
      });
      pauseButton.addEventListener('click', function () {
        bgVideo.pause();
      });
      bgVideo.addEventListener('play', function () {
        toggle_play_status('hide');
      });
      bgVideo.addEventListener('pause', function () {
        toggle_play_status('show');
      });
    }

    function toggle_play_status() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'hide';

      if (mode == 'hide') {
        playButton.classList.add('hidden');
        pauseButton.classList.remove('hidden');
      } else {
        playButton.classList.remove('hidden');
        pauseButton.classList.add('hidden');
      }
    }
  }
});